import { InjectionToken, Injector } from '@angular/core';

import { ScrollableDirective } from '../core/overlay/scroll/scrollable.directive';
import { DialogRef } from './dialog-ref';

export const DialogData = new InjectionToken<any>('DialogData');

/** Custom injector type specifically for instantiating components with a dialog. */
export class DialogInjector implements Injector {
  constructor(
    private parentInjector: Injector,
    private dialogRef: DialogRef,
    private scrollable: ScrollableDirective,
    private dialogData: any,
    private level: number,
  ) {}

  public get(token: any, notFoundValue?: any): any {
    if (token === 'overlayLevel') {
      return this.level;
    }

    if (token === ScrollableDirective) {
      return this.scrollable;
    }

    if (token === DialogRef) {
      return this.dialogRef;
    }

    if (token === DialogData && this.dialogData) {
      return this.dialogData;
    }

    return this.parentInjector.get<any>(token, notFoundValue);
  }
}
